
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import WrapperIntl from './WrapperIntl';
import ErrorBoundary from './components/ErrorBoundary';
import logger from './utils/frontendLogger';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Set <html lang="..."> dynamically based on browser/user language
const supportedLangs = ['en', 'fr', 'de', 'it', 'es'];
function getPreferredLang() {
  // Try to get from localStorage, then browser, fallback to 'en'
  const stored = localStorage.getItem('lang');
  if (stored && supportedLangs.includes(stored)) return stored;
  const browserLang = navigator.language?.slice(0, 2);
  if (browserLang && supportedLangs.includes(browserLang)) return browserLang;
  return 'en';
}
document.documentElement.lang = getPreferredLang();

const rootElement = document.getElementById('root');

// If launched in standalone (homescreen) mode on mobile, and user is not
// authenticated, redirect to the manager landing so users start at /manager.
try {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  if (isStandalone) {
    const token = sessionStorage.getItem('token');
    if (!token && window.location.pathname !== '/manager') {
      window.location.replace('/manager');
    }
  }
} catch (e) {
  // Defensive: ignore if navigator APIs are not available
  console.warn('[PWA] standalone redirect check failed', e);
}

// Use hydrate for pre-rendered content, render for normal SPA
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <ErrorBoundary>
        <WrapperIntl>
          <App />
        </WrapperIntl>
      </ErrorBoundary>
    </React.StrictMode>,
    rootElement
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundary>
        <WrapperIntl>
          <App />
        </WrapperIntl>
      </ErrorBoundary>
    </React.StrictMode>,
    rootElement
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Log initial page load
logger.pageView('app_load', {
  referrer: document.referrer,
  screenResolution: `${window.screen.width}x${window.screen.height}`
});

// PWA service worker registration - only for superadmin users
// Check will be performed after authentication
window.enablePWAForSuperAdmin = () => {
  const code = sessionStorage.getItem('code');
  const isSuperAdmin = code === '1000'; // Code 1000 is superadmin
  
  if (isSuperAdmin) {
    serviceWorkerRegistration.register({
      onSuccess: () => console.log('[PWA] App is ready for offline use (superadmin)'),
      onUpdate: (registration) => {
        console.log('[PWA] New version available. Refresh to update.');
      }
    });
    console.log('[PWA] Service worker enabled for superadmin (code: 1000)');
  } else {
    console.log('[PWA] Service worker disabled - superadmin access required (current code:', code, ')');
  }
};

// Note: Call window.enablePWAForSuperAdmin() after successful login
